import classNames from 'classnames'
import { MyDialog } from 'components/MyDialog'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setActiveTrap } from 'redux/reducers/modal'
import { AccountHomeLink } from '../AccountHomeLink/AccountHomeLink'

import classes from './AllOptionsModal.module.scss'
import { usePersonalizedAllOptions } from './usePersonalizedAllOptions'

type AllOptionsModalProps = {
  eMsnEnrolled?: boolean
}
export const AllOptionsModal = ({
  eMsnEnrolled = false
}: AllOptionsModalProps) => {
  const { t } = useTranslation('accountHome', { keyPrefix: 'allOptions' })
  const history = useHistory()

  // TODO - remove this once we can switch over to native <dialog>
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setActiveTrap({ isActiveTrap: true }))

    return () => {
      dispatch(setActiveTrap({ isActiveTrap: false }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    history.replace('/home')
  }

  const items = usePersonalizedAllOptions({ eMsnEnrolled })
  const sections: Array<keyof typeof items> = [
    'providers',
    'claims',
    'plans',
    'premiums',
    'settings'
  ]

  return (
    <MyDialog
      className={classes.dialog}
      heading={t('heading')}
      headingClassName="ds-text-heading--2xl ds-u-margin-bottom--5"
      containerId="medicare-my-acct-home-all-options"
      closeButtonAriaLabel={t('Close')}
      onClose={handleClose}
      width="full"
    >
      <div className="my-u-position--relative">
        <div className={classes.bg}></div>
        <div className={classNames('ds-u-padding-top--5', classes.content)}>
          {sections.map((section, idx) => (
            <section
              key={section}
              className={idx > 0 ? 'ds-u-margin-top--7' : ''}
            >
              <h3 className="ds-text-heading--xl">
                {t(`sectionHeadings.${section}`)}
              </h3>
              <ul className={`${classes.gridContainer} ds-c-list--bare ds-u-padding-left--0`}>
                {items[section].map((item) => (
                  <li className={classes.item} key={item}>
                    <AccountHomeLink item={item} isInModal />
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </MyDialog>
  )
}
